export class FooterAuth {
  ativo: boolean;
  titulo: string;
  subTitulo: string;
  buttonLink: ButtonAuth;
  buttonAtendimentoWpp: ButtonAuth;

  constructor(other?: any) {
    if(other != null) {
      this.ativo = other.ativo;
      this.titulo = other.titulo;
      this.subTitulo = other.subTitulo;
      this.buttonLink = new ButtonAuth(other?.buttonLink);
      this.buttonAtendimentoWpp = new ButtonAuth(other?.buttonAtendimentoWpp);
    }
  }
}
export class ButtonAuth {
  ativo: boolean = true;
  label: string;
  routerLink: string;
  icone: string;

  constructor(other?: any) {
    if(other !== null) {
      this.ativo = other?.ativo;
      this.label = other?.label;
      this.routerLink = other?.routerLink;
      this.icone = other?.icone;
    }
  }
}
